import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateBodytypeForm from '../../../modules/bodyTypes/components/CreateBodytypeForm';
import { useParams } from 'react-router-dom';

const CreateBodytype = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const title = id ? t('edit_body_type') : t('create_body_type');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/body-types/create-body-type' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateBodytypeForm />
    </div>
  );
};

export default CreateBodytype;
